var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt20 p20 tc reviews" },
    [
      _c(
        "div",
        { staticClass: "pega-text-count-area real-intentions clearfix" },
        [
          _vm.textCountMode
            ? _c("text-count", {
                attrs: {
                  "data-test": "text-count",
                  name: "「社員からの評判」は企業様管理画面でのみ追加・修正が可能です。営業担当者・制作担当者側では編集できません。",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("img", {
        staticClass: "mb10 reviews-img clearfix",
        attrs: {
          src: _vm.userOfferImageUrlForPc + "/reviews.png",
          alt: "reviews",
          "data-test": "real-intention-img",
        },
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "fs15 fwB" }, [
        _vm._v("\n    社員からの評判・口コミをチェック！\n  "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.realIntentions, function (realIntention, i) {
        return _c(
          "div",
          { key: "real-intention-" + i, staticClass: "mt20" },
          [
            _c(
              "job-preview-right-column",
              _vm._g(
                {
                  attrs: {
                    "text-count-mode": _vm.textCountMode,
                    "highlight-mode": _vm.highlightMode,
                    "comment-class": "real-intention",
                    "comment-highlights": _vm.getAnyCommentHighlights(
                      _vm.targetIdMap.realIntention.prefix,
                      i
                    ),
                  },
                },
                _vm.$listeners
              )
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "review-li-dot",
              attrs: { src: _vm.userOfferImageUrlForPc + "/icn_circle.png" },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tl fs13 pl20 pr5 review-inner two-line" },
              [
                _c("p", [
                  _c("span", {
                    attrs: {
                      id: _vm.targetIdMap.realIntention.answer + "-" + i,
                      "data-test": "answer-" + i,
                    },
                    domProps: { textContent: _vm._s(realIntention.answer1) },
                  }),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("p", {
              staticClass: "realintention-right mt5 clearfix",
              attrs: {
                id: _vm.targetIdMap.realIntention.genderAndCareer + "-" + i,
                "data-test": "gender-and-career-" + i,
              },
              domProps: {
                textContent: _vm._s(
                  "(" +
                    realIntention.gender.name +
                    "/" +
                    realIntention.career +
                    ")"
                ),
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("p", { staticClass: "reviews-link btn-style-02 mt20" }, [
        _c(
          "a",
          {
            style:
              "background: url(" +
              _vm.userCommonImageUrlForPc +
              "/icn_arrow_05.png) no-repeat 8px center;",
            attrs: { target: "_blank", "data-test": "button" },
          },
          [
            _c("span", [
              _vm._v(
                _vm._s(_vm.companyName) + "の社員からの評判・口コミをすべて見る"
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }